//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Translated from '~/components/legacy/global/translated'

export default {
  components: {
    Translated
  },
  props: {
    method: { type: String, default: '' },
    preorder: { type: Boolean, default: false },
    preorderDateUnix: { type: Number, default: -1 },
    longFormat: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    productMessage: { type: Boolean, default: false },
    onlyDigitalGiftCards: { type: Boolean, default: false },
    onlyGiftCards: { type: Boolean, default: false },
    delayedDespatchUnix: { type: Number, default: -1 }
  },
  computed: {
    ...mapGetters({
      destination: 'store/shippingCountry',
      destinationName: 'store/shippingCountryName',
      details: 'store/shippingDetails',
      cutoff: 'store/shippingCutoff',
      guaranteedDeliveryEnabled: 'store/shippingGuaranteed',
      nonDespatchDays: 'store/shippingNonDespatchDays',
      nonShipDays: 'store/shippingNonShipDays'
    }),

    nextDespatch () {
      const datetime = this.$moment().tz('Europe/London')
      let [despatching, cutoff] = this.checkIfDespatching(datetime)
      while (!despatching) {
        [despatching, cutoff] = this.checkIfDespatching(datetime.add(1, 'hours'))
      }
      return datetime.startOf('day').add(cutoff, 'hours')
    },

    isSecondClass () {
      return (this.method || '').toLowerCase().includes('2nd_class')
    },

    isSaturdayDelivery () {
      return (this.method || '').toLowerCase().includes('saturday')
    },

    isClickAndCollect () {
      return (this.method || '').toLowerCase().includes('click_and_collect')
    },

    transitTime () {
      // Override for click and collect
      if (this.isClickAndCollect) return [0, 0]

      let min, max
      if (`${this.details.transit}`.includes('-')) {
        [min, max] = this.details.transit.split('-').map(str => parseInt(str))
      } else {
        min = max = parseInt(this.details.transit)
      }

      // Extend transit time for 2nd class
      let minExtension = 0
      let maxExtension = 0
      if (this.isSecondClass) {
        minExtension = minExtension > 1 ? minExtension : 1
        maxExtension = maxExtension > 3 ? maxExtension : 3
      }

      // NOT tested - pulled from old system
      // [(this.item || null), ...(this.items || [])].filter(sku => sku).forEach(sku => {
      //     if (sku.startsWith('velans')) {
      //         minExtension = [minExtension, 1].max()
      //         maxExtension = [maxExtension, 1].max()
      //     }
      // })

      min += minExtension
      max += maxExtension

      if (min > max) {
        // Shouldn't be possible, flip them
        const oldMin = min
        min = max
        max = oldMin
      }

      return [min, max]
    },

    deliveryEstimate () {
      // Get delivery estimate for the min and max delivery windows
      const deliveryMin = this.transitToDate(this.transitTime[0])
      const deliveryMax = this.transitToDate(this.transitTime[1])
      return [deliveryMin, deliveryMax]
    },

    isGuaranteed () {
      if (this.deliveryEstimate[0].valueOf() !== this.deliveryEstimate[1].valueOf()) return false
      if (this.destination !== 'GB') return false
      return this.guaranteedDeliveryEnabled
    },

    shortMessage () {
      const [deliveryMin, deliveryMax] = this.deliveryEstimate

      if (this.isSaturdayDelivery) return this.$tr('on Saturday')

      // Delivery expected on a specific day
      if (deliveryMin.valueOf() === deliveryMax.valueOf()) {
        // If estimate is today then return 'Today' (Click and Collect)
        if (deliveryMin.date() === this.$moment().date()) {
          return this.$tr('Today')
        }

        // If estimate is tomorrow then return 'Tomorrow'
        if (deliveryMin.date() === this.$moment().add(1, 'days').date()) {
          return this.$tr('Tomorrow')
        }

        // If estimate is within the next week then return the weekday
        if (this.$moment.duration(deliveryMin.diff(this.$moment())).days() < 6) {
          return `${this.$tr('on')} ${deliveryMin.format('dddd')}`
        }

        return `${this.$tr('on')} ${deliveryMin.format('dddd Do MMMM')}`
      }

      return `${deliveryMin.format('dddd Do MMMM')} - ${deliveryMax.format('dddd Do MMMM')}`
    },

    countdown () {
      const timeToDespatch = this.$moment.duration(this.nextDespatch.diff(this.$moment()))
      const days = timeToDespatch.days()
      const daysText = this.$trp('day', 'days', days)
      const hours = timeToDespatch.hours()
      const hoursText = this.$trp('hour', 'hours', hours)
      const minutes = timeToDespatch.minutes()
      const minutesText = this.$trp('minute', 'minutes', minutes)

      let countdown = minutes ? `${minutes} ${minutesText}` : ''
      countdown = (hours ? `${hours} ${hoursText}${countdown ? ' ' + this.$tr('and') + ' ' : ''}` : '') + countdown
      countdown = (days ? `${days} ${daysText}${countdown ? ' ' : ''}` : '') + countdown

      return countdown
    },

    formattedPreorderDate () {
      if (!this.preorder || this.preorderDateUnix <= 0) return null
      const preorderDate = this.$moment(this.preorderDateUnix * 1000).add(3, 'days') // Default to adding three extra days
      if (preorderDate < this.$moment().add(1, 'days')) preorderDate.add(3, 'days')
      return preorderDate.format('Do MMMM')
    },

    methodName () {
      if (this.onlyGiftCards) return 'Royal Mail 1st Class'
      return this.details.method
    },

    delayedDespatchDate () {
      if (!this.delayedDespatchUnix || this.delayedDespatchUnix <= 0) return null
      const delayedDespatchDate = this.$moment(this.delayedDespatchUnix * 1000)
      
      // If depatch is delayed until today then just default to the normal message
      if (delayedDespatchDate < this.$moment().add(1, 'days')) return null
      return delayedDespatchDate.format('dddd Do MMMM')
    }
  },
  methods: {
    checkIfDespatching (datetime) {
      // Are we despatching today?
      let despatching = true
      let despatchCutoff = this.cutoff
      if (datetime.weekday() === 0 || datetime.weekday() === 6) {
        // We don't despatch on weekends
        despatching = false
      }

      const date = datetime.format('YYYY-MM-DD')
      if (date in this.nonDespatchDays) {
        // There's something special about today
        if (this.nonDespatchDays[date] === null) {
          despatching = false
        } else {
          despatchCutoff = this.nonDespatchDays[date]
        }
      }

      if (datetime.hour() >= despatchCutoff) {
        // We don't despatch after 3pm on most days, sometimes earlier
        despatching = false
      }

      return [despatching, despatchCutoff]
    },

    transitToDate (transit) {
      const datetime = this.nextDespatch.clone()

      while (transit > 0) {
        datetime.add(1, 'days')

        // Add an extra day for weekends or bank holidays
        // Except Saturdays in the UK
        if (datetime.weekday() === 0 || /* sunday */
            (datetime.weekday() === 6 && !(this.method || '').includes('Saturday')) || /* saturday not Saturday delivery */
            (datetime.format('YYYY-MM-DD') in this.nonDespatchDays &&
              this.nonDespatchDays[datetime.format('YYYY-MM-DD')] === null) /* bank holiday */
        ) {
          datetime.add(1, 'days')
        } else {
          transit -= 1
        }
      }
      return datetime
    }
  }
}
